<template>
  <div class="vpn-download">
    <HeadNav selectedLanguage="en" page="download" />

    <main>
      <section class="download-hero">
        <div class="hero-orb" aria-hidden="true" />
        <div class="container download-layout">
          <div class="download-copy">
            <p class="eyebrow">Secure VPN APK</p>
            <h1>Download Secure VPN APK</h1>
            <p class="lead">Protect your privacy and browse securely with a fast, free VPN. Connect in one tap, access global servers, and enjoy a safer internet experience on your device.</p>
            <h2>One Tap, and your privacy is set!</h2>
            <p class="badge">100% Free · Latest Version</p>
            <div class="download-actions">
              <a
                class="download-btn"
                href="https://apk.secureproxyvpn.com/android/apk/SecureVPN-release-1.0.2_c-20260710171019.apk"
                rel="noopener noreferrer"
              >Get APK</a>
              <a
                class="download-btn download-btn-play"
                href="https://play.google.com/store/apps/details?id=com.secure.vpn.private.browser&referrer=utm_source%3Dweb"
                target="_blank"
                rel="noopener noreferrer"
              >Google Play</a>
            </div>
            <p class="available">Available for: Chrome · Edge · Android</p>
          </div>
          <div class="preview-wrap">
            <img class="download-preview" :src="previewImage" alt="Secure VPN app preview">
          </div>
        </div>
      </section>

      <section class="setup-section">
        <div class="container">
          <div class="section-head">
            <h2>How to Set Up SecureVPN</h2>
          </div>
          <div class="setup-grid">
            <article class="setup-card">
              <div class="setup-copy">
                <span>1</span>
                <h3>Download the app</h3>
                <p>Choose your platform above and install the SecureVPN app.</p>
              </div>
              <img :src="downloadStepImage" alt="Download SecureVPN app">
            </article>

            <article class="setup-card text-only">
              <div class="setup-copy">
                <span>2</span>
                <h3>Create an account and choose a server</h3>
                <p>Sign up and choose a region that fits your needs.</p>
              </div>
            </article>

            <article class="setup-card">
              <div class="setup-copy">
                <span>3</span>
                <h3>Connect and browse</h3>
                <p>Tap connect. Your internet connection is protected through a VPN server now.</p>
              </div>
              <img :src="useVpnImage" alt="Use Secure VPN">
            </article>
          </div>
          <p class="disclaimer">Secure VPN services may not be available in certain regions, including mainland China. Users are responsible for checking local regulations and service availability before use.</p>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/vpn-theme.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Download',
  components: {
    HeadNav,
  },
  data() {
    return {
      previewImage: require('@/assets/vpn/download-preview.png'),
      downloadStepImage: require('@/assets/vpn/download-step.webp'),
      useVpnImage: require('@/assets/vpn/use-vpn.webp'),
    };
  },
};
</script>

<style lang="scss" scoped>
.vpn-download {
  background:
    radial-gradient(ellipse 70% 40% at 80% 0%, rgba(91, 79, 232, 0.1), transparent 55%),
    #f5f4fb;
  color: var(--vpn-ink);
  font-family: var(--vpn-font);
}

.container {
  width: var(--vpn-container);
  margin: 0 auto;
}

.download-hero {
  position: relative;
  overflow: hidden;
  padding: 36px 0 34px;
  background:
    radial-gradient(ellipse 60% 80% at 85% 30%, rgba(91, 79, 232, 0.28), transparent 50%),
    linear-gradient(145deg, #12122e 0%, #1e1b4b 55%, #2a2a6a 100%);
  color: #fff;
}

.hero-orb {
  position: absolute;
  width: 360px;
  height: 360px;
  left: -80px;
  bottom: -120px;
  background: radial-gradient(circle, rgba(139, 124, 255, 0.22), transparent 70%);
  pointer-events: none;
}

.download-layout {
  position: relative;
  display: grid;
  grid-template-columns: 1.28fr 0.72fr;
  gap: 28px;
  align-items: center;
}

.eyebrow {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--vpn-teal-bright);
}

h1 {
  margin: 0 0 18px;
  font-size: clamp(32px, 3.4vw, 44px);
  line-height: 1.08;
  letter-spacing: 0;
  font-weight: 800;
  white-space: nowrap;
}

.lead {
  margin: 0;
  font-size: 17px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.84);
}

.download-copy h2 {
  margin: 22px 0 10px;
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.badge {
  margin: 0 0 22px;
  font-weight: 800;
  color: var(--vpn-teal-bright);
}

.download-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  padding: 0 28px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, var(--vpn-teal-bright), var(--vpn-teal));
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  font-family: inherit;
  text-decoration: none;
  cursor: pointer;
  opacity: 0.95;
  box-shadow: 0 14px 30px rgba(91, 79, 232, 0.32);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 34px rgba(91, 79, 232, 0.4);
}

.download-btn-play {
  background: linear-gradient(135deg, #34a853, #188038);
  box-shadow: 0 14px 30px rgba(52, 168, 83, 0.28);
}

.download-btn-play:hover {
  box-shadow: 0 16px 34px rgba(52, 168, 83, 0.38);
}

.available {
  margin-top: 14px;
  color: rgba(207, 225, 237, 0.9);
  font-size: 14px;
}

.preview-wrap {
  display: flex;
  justify-content: center;
  animation: vpn-rise 0.8s ease both;
}

.download-preview {
  width: min(100%, 270px);
  max-height: 380px;
  object-fit: contain;
  filter: drop-shadow(0 28px 50px rgba(0, 0, 0, 0.35));
}

.setup-section {
  padding: 84px 0;
}

.section-head {
  margin-bottom: 28px;
}

.setup-section h2 {
  margin: 0;
  font-size: clamp(28px, 3.4vw, 38px);
  letter-spacing: -0.02em;
  font-weight: 800;
}

.setup-grid {
  display: grid;
  gap: 18px;
}

.setup-card {
  display: grid;
  // SecureVPN “How to Set Up”模块：改为上下布局（文字在上、图片在下）
  grid-template-columns: 1fr;
  gap: 18px;
  align-items: start;
  padding: 28px;
  border: 1px solid var(--vpn-line);
  border-radius: var(--vpn-radius);
  background: #fff;
  box-shadow: var(--vpn-shadow-soft);
}

.setup-card.text-only {
  grid-template-columns: 1fr;
}

.setup-copy span {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--vpn-teal), var(--vpn-teal-deep));
  color: #fff;
  font-weight: 800;
  box-shadow: 0 8px 18px rgba(91, 79, 232, 0.28);
}

.setup-card h3 {
  margin: 14px 0 10px;
  font-size: 22px;
  font-weight: 700;
  color: var(--vpn-ink);
}

.setup-card p,
.disclaimer {
  margin: 0;
  font-size: 16px;
  line-height: 1.7;
  color: var(--vpn-ink-soft);
}

.setup-card img {
  width: 100%;
  border-radius: 14px;
  border: 1px solid var(--vpn-line);
}

.disclaimer {
  margin-top: 28px;
  padding: 18px 20px;
  border-left: 3px solid var(--vpn-teal);
  background: linear-gradient(90deg, rgba(91, 79, 232, 0.12), rgba(91, 79, 232, 0.04));
  border-radius: var(--vpn-radius-sm);
  color: var(--vpn-ink);
}

@media (max-width: 900px) {
  .download-layout,
  .setup-card {
    grid-template-columns: 1fr;
  }

  .download-hero {
    padding: 34px 0 32px;
  }

  h1 {
    font-size: clamp(28px, 6.2vw, 38px);
  }

  .download-preview {
    width: min(100%, 230px);
    max-height: 320px;
  }

  .download-actions,
  .download-btn {
    width: 100%;
  }
}

@media (max-width: 520px) {
  h1 {
    font-size: clamp(22px, 6.4vw, 28px);
  }
}
</style>
